import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaPhone,
  FaEnvelope,
  FaWhatsapp,
  FaBuilding,
  FaTimes,
  FaUser,
  FaGlobe,
  FaPaperPlane,
} from "react-icons/fa";
import { IoMdBuild, IoLogoWhatsapp } from "react-icons/io";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import GameLogo from "../../assets/image/Game_Logo.png";
import "../Footer/Footer.css";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";

const Footer = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://embed.tawk.to/6853f68606c44e190eb392ad/1iu3vm0ac";
    script.async = true;
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector(
        `script[src="${script.src}"]`
      );
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  // WhatsApp Widget state
  const [isHovered, setIsHovered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [ripples, setRipples] = useState([]);
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    setIsVisible(true);
    const rippleArray = Array.from({ length: 3 }, (_, i) => ({
      id: i,
      delay: i * 0.7,
    }));
    setRipples(rippleArray);
    const particleArray = Array.from({ length: 6 }, (_, i) => ({
      id: i,
      x: Math.random() * 60 + 20,
      y: Math.random() * 60 + 20,
      delay: Math.random() * 2,
    }));
    setParticles(particleArray);
  }, []);

  // Updated container style for better responsive behavior
  const containerStyle = {
    position: "fixed",
    right: "20px",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 1000,
    transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
    opacity: isVisible ? 1 : 0,
    filter: isVisible ? "none" : "blur(10px)",
  };

  // Mobile responsive adjustments
  const mobileContainerStyle = {
    ...containerStyle,
    right: "10px",
    transform: "translateY(-50%) scale(0.9)",
  };

  const widgetContainerStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    cursor: "pointer",
    position: "relative",
  };

  const textBubbleStyle = {
    backgroundColor: "rgba(37, 211, 102, 0.95)",
    backdropFilter: "blur(10px)",
    color: "#fff",
    padding: "12px 20px",
    borderRadius: "25px",
    fontSize: "15px",
    fontWeight: "600",
    marginRight: "15px",
    position: "relative",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    opacity: isHovered ? 1 : 0,
    visibility: isHovered ? "visible" : "hidden",
    transform: isHovered
      ? "scale(1) translateX(0px)"
      : "scale(0.8) translateX(10px)",
    transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    whiteSpace: "nowrap",
    maxWidth: "200px",
  };

  const textBubbleArrowStyle = {
    position: "absolute",
    right: "-8px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "0",
    height: "0",
    borderTop: "8px solid transparent",
    borderBottom: "8px solid transparent",
    borderLeft: "8px solid rgba(37, 211, 102, 0.95)",
    opacity: isHovered ? 1 : 0,
    transition: "opacity 0.4s ease 0.1s",
  };

  const iconWrapperStyle = {
    position: "relative",
    width: "70px",
    height: "70px",
  };

  const iconContainerStyle = {
    width: "60px",
    height: "60px",
    background: "linear-gradient(135deg, #25d366 0%, #20c55a 100%)",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    zIndex: 3,
    border: "2px solid rgba(255, 255, 255, 0.2)",
    transform: isHovered ? "scale(1.1)" : "scale(1)",
    transition: "all 0.3s ease",
    textDecoration: "none",
  };

  const iconStyle = {
    fontSize: "28px",
    color: "#ffffff",
    zIndex: 4,
    textShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
    transform: isHovered ? "scale(1.1)" : "scale(1)",
    transition: "all 0.2s ease",
  };

  const particleStyle = (particle) => ({
    position: "absolute",
    top: `${particle.y}%`,
    left: `${particle.x}%`,
    width: "3px",
    height: "3px",
    background: "rgba(37, 211, 102, 0.8)",
    borderRadius: "50%",
    opacity: isHovered ? 1 : 0,
    transform: isHovered ? "scale(1)" : "scale(0)",
    transition: `all 0.5s ease ${particle.delay}s`,
    animation: isHovered
      ? `float 3s ease-in-out ${particle.delay}s infinite`
      : "none",
  });

  return (
    <>
      {/* WhatsApp Widget */}
      <style>{`
  @keyframes rippleAnim {
    0% { transform: scale(0.5); opacity: 1; }
    100% { transform: scale(2); opacity: 0; }
  }

  @keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-10px) rotate(180deg); }
  }

  .whatsapp-container {
    position: fixed;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1000;
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }

  @media (max-width: 768px) {
    .whatsapp-container {
      top: auto !important;
      bottom: 150px !important;
      right: 15px !important;
      transform: none !important;
    }

    .whatsapp-text-bubble {
      font-size: 13px !important;
      padding: 10px 16px !important;
      max-width: 150px !important;
    }
  }

  @media (max-width: 480px) {
    .whatsapp-container {
      right: 10px !important;
      bottom: 87px !important;
    }

    .whatsapp-text-bubble {
      display: none !important;
    }
  }
`}</style>

      <div className="whatsapp-container">
        <div
          className="whatsapp-widget"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            cursor: "pointer",
            position: "relative",
          }}
        >
          <div
            className="text-bubble whatsapp-text-bubble"
            style={{
              backgroundColor: "rgba(37, 211, 102, 0.95)",
              backdropFilter: "blur(10px)",
              color: "#fff",
              padding: "12px 20px",
              borderRadius: "25px",
              fontSize: "15px",
              fontWeight: "600",
              marginRight: "15px",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              whiteSpace: "nowrap",
              maxWidth: "200px",
              transition: "all 0.4s ease",
              opacity: isHovered ? 1 : 0,
              visibility: isHovered ? "visible" : "hidden",
              transform: isHovered ? "scale(1)" : "scale(0.9)",
            }}
          >
            Chat with us on WhatsApp
            <div
              style={{
                position: "absolute",
                right: "-8px",
                top: "50%",
                transform: "translateY(-50%)",
                width: "0",
                height: "0",
                borderTop: "8px solid transparent",
                borderBottom: "8px solid transparent",
                borderLeft: "8px solid rgba(37, 211, 102, 0.95)",
                opacity: isHovered ? 1 : 0,
                transition: "opacity 0.4s ease 0.1s",
              }}
            ></div>
          </div>

          <div style={{ position: "relative", width: "70px", height: "70px" }}>
            {ripples.map((ripple) => (
              <div
                key={ripple.id}
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  width: "100%",
                  height: "100%",
                  borderRadius: "50%",
                  background: "rgba(37, 211, 102, 0.3)",
                  animation: `rippleAnim 2s infinite ${ripple.delay}s`,
                }}
              ></div>
            ))}

            <a
              href="https://wa.me/+919655022224"
              target="_blank"
              rel="noopener noreferrer"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              style={{
                width: "60px",
                height: "60px",
                background: "linear-gradient(135deg, #25d366 0%, #20c55a 100%)",
                borderRadius: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                zIndex: 3,
                border: "2px solid rgba(255, 255, 255, 0.2)",
                transform: isHovered ? "scale(1.1)" : "scale(1)",
                transition: "all 0.3s ease",
                textDecoration: "none",
              }}
            >
              <i
                className="fa-brands fa-whatsapp"
                style={{
                  fontSize: "28px",
                  color: "#ffffff",
                  textShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
                }}
              ></i>
              {particles.map((particle) => (
                <div
                  key={particle.id}
                  style={{
                    position: "absolute",
                    top: `${particle.y}%`,
                    left: `${particle.x}%`,
                    width: "3px",
                    height: "3px",
                    background: "rgba(37, 211, 102, 0.8)",
                    borderRadius: "50%",
                    opacity: isHovered ? 1 : 0,
                    transform: isHovered ? "scale(1)" : "scale(0)",
                    transition: `all 0.5s ease ${particle.delay}s`,
                    animation: isHovered
                      ? `float 3s ease-in-out ${particle.delay}s infinite`
                      : "none",
                  }}
                ></div>
              ))}
            </a>
          </div>
        </div>
      </div>

      {/* Footer Content */}
      <div className="container-fluid" style={{ backgroundColor: "#050708" }}>
        <div className="container">
          <footer
            className="footer-gradient text-white py-5"
            style={{ position: "relative", zIndex: 1 }}
          >
            <Container fluid className="px-3 px-md-4">
              <Row className="gy-4 justify-content-center">
                <Col lg={3} md={12}>
                  <div className="mb-3">
                    <img
                      src={GameLogo}
                      alt="Company logo"
                      className="img-fluid mb-3 footer-logo"
                    />
                  </div>
                  <p className="small fs-6 text-break">
                    Clarity gives you the blocks and components you need to
                    create a truly professional website.
                  </p>
                  <div className="d-flex flex-lg-row flex-row gap-2 align-items-start align-items-lg-center">
                    {[
                      {
                        net: "facebook-f",
                        url: "https://www.facebook.com/share/16TtByVBEd/",
                      },
                      {
                        net: "instagram",
                        url: "https://www.instagram.com/shivgames_/",
                      },
                      {
                        net: "linkedin",
                        url: "https://www.linkedin.com/company/shiv-games-it-solutions/",
                      },
                      {
                        net: "whatsapp",
                        url: "https://wa.me/+919655022224",
                      },
                      {
                        net: "google-plus-g",
                        url: "https://www.google.com/search?q=Shiv+Games+IT+Solutions+Private+Limited&rlz=1C1VDKB_enIN1115IN1115&oq=shiv+Games+IT+Solutions+Private+Limited&gs_lcrp=EgZjaHJvbWUqDggAEEUYJxg7GIAEGIoFMg4IABBFGCcYOxiABBiKBTINCAEQLhivARjHARiABDIHCAIQABiABDIICAMQABgWGB4yCggEEAAYgAQYogQyBggFEEUYPTIGCAYQRRg8MgYIBxBFGD3SAQgxNDk3ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8",
                      },
                    ].map(({ net, url }) => (
                      <a
                        key={net}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon d-flex align-items-center justify-content-center rounded-circle text-white text-decoration-none border border-white"
                        style={{
                          width: "38px",
                          height: "38px",
                          transition: "all 0.3s ease",
                        }}
                      >
                        <i className={`fab fa-${net} fs-5`}></i>
                      </a>
                    ))}
                  </div>
                </Col>

                <Col lg={2} md={6}>
                  <h5 className="text-uppercase fw-bold mb-4 color-title">
                    Quick Links
                  </h5>
                  <div className="d-flex flex-column">
                    {[
                      { label: "Home", path: "/" },
                      { label: "About Us", path: "/about" },
                      { label: "Services", path: "/services" },
                      { label: "Technology", path: "/technology" },
                      { label: "Portfolio", path: "/portfolio" },
                      { label: "Trainings", path: "/trainings" },
                      { label: "Career", path: "/career" },
                      { label: "Blog", path: "/blog" },
                      { label: "Contact Us", path: "/contact" },
                    ].map(({ label, path }) => (
                      <Link
                        key={label}
                        to={path}
                        className="text-white text-decoration-none fw-medium mb-2 footer-link"
                      >
                        {label}
                      </Link>
                    ))}
                  </div>
                </Col>

                <Col lg={3} md={6}>
                  <h5 className="text-uppercase fw-bold mb-4 color-title">
                    Services
                  </h5>
                  <div className="d-flex flex-column">
                    {[
                      {
                        label: "Drone Services & Education",
                        path: "/services/DroneAndEducation",
                      },
                      {
                        label: "IOT Solutions",
                        path: "/services/IotSolutions",
                      },
                      {
                        label: "Robotics Solutions",
                        path: "/services/SoftwareDevelopment",
                      },
                      {
                        label: "Artificial Intelligence",
                        path: "/services/SoftwareDevelopment",
                      },
                      {
                        label: "Software Development",
                        path: "/services/SoftwareDevelopment",
                      },
                      // {
                      //   label: "Game Development",
                      //   path: "/services/GameDevelopment",
                      // },
                      // {
                      //   label: "Casino & Sportsbook API Integration",
                      //   path: "/services/CasinoSportsbook",
                      // },
                      // {
                      //   label: "IoT Embedded System",
                      //   path: "/services/IoTSolutions",
                      // },
                      // {
                      //   label: "AR/VR Application Development",
                      //   path: "/services/ARVRApplicationDevelopment",
                      // },
                      {
                        label: "Website Development",
                        path: "/services/WebsiteDevelopment",
                      },
                      {
                        label: "App Development",
                        path: "/services/AppDevelopment",
                      },
                      {
                        label: "DevOps Solutions",
                        path: "/services/DevOpsSolutions",
                      },
                      // {
                      //   label: "IT Support & Solutions",
                      //   path: "/services/ITSupportSolutions",
                      // },
                      {
                        label: "Training Programs",
                        path: "/services/TrainingPrograms",
                      },
                      // {
                      //   label: "Digital Marketing",
                      //   path: "/services/DigitalMarketing",
                      // },
                    ].map(({ label, path }, index) => (
                      <Link
                        key={index}
                        to={path}
                        className="text-white text-decoration-none fw-medium mb-2 footer-link"
                      >
                        {label}
                      </Link>
                    ))}
                  </div>
                </Col>

                <Col lg={2} md={6}>
                  <h5 className="text-uppercase fw-bold mb-4 color-title">
                    Help Center
                  </h5>
                  <div className="d-flex flex-column">
                    {[
                      { label: "Terms & Conditions", path: "/termscondition" },
                      { label: "Privacy Policy", path: "/privacypolicy" },
                    ].map(({ label, path }) => (
                      <Link
                        key={label}
                        to={path}
                        className="text-white text-decoration-none fw-medium mb-2 footer-link"
                      >
                        {label}
                      </Link>
                    ))}
                  </div>
                </Col>

                <Col lg={2} md={6}>
                  <h5 className="text-uppercase fw-bold mb-4 color-title">
                    Office Location
                  </h5>
                  <div className="mb-3 d-flex align-items-start">
                    <span className="icon-box me-2 flex-shrink-0">
                      <FaMapMarkerAlt />
                    </span>
                    <span className="text-white fw-medium text-break">
                      {/* No. 48, 2nd Floor, Lotus Castle, First Main Rd, near
                      Seasons Seafood Restuarant, Radha Nagar, Perumbakkam,
                      Chennai, Tamil Nadu 600100 */}
                      No. 35/58, Agramthen, Main Road, Kovilancheri, Chennai - 600126, Tamil Nadu
                    </span>
                  </div>

                  <div className="mb-3 d-flex align-items-start">
                    <span className="icon-box me-2 flex-shrink-0">
                      <FaPhoneAlt />
                    </span>
                    <span className="text-white fw-medium">
                      +91 96550 22226
                    </span>
                  </div>

                  <div className="mb-3 d-flex align-items-start">
                    <span className="icon-box me-2 flex-shrink-0">
                      <FaWhatsapp />
                    </span>
                    <span className="text-white fw-medium">
                      +91 96550 22224
                    </span>
                  </div>

                  <div className="mb-3 d-flex align-items-start">
                    <span className="icon-box me-2 flex-shrink-0">
                      <FaEnvelope />
                    </span>
                    <span className="text-white fw-medium text-break">
                      info@theshivgames.com
                    </span>
                  </div>
                </Col>
              </Row>

              <hr className="my-4 border-top border-white opacity-25" />
              <p className="text-center small mb-0">
                © Copyright 2025. All Rights Reserved by SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED
              </p>
            </Container>

            {/* Styles */}
            <style>{`
              .footer-gradient {
                overflow-x: hidden;
              }

              .footer-logo {
                max-width: 150px;
                min-width: 100px;
                height: auto;
              }

              .social-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 38px;
                aspect-ratio: 1/1;
                border-radius: 50%;
                border: 1px solid white;
                transition: all 0.3s ease;
              }

              .social-icon:hover {
                transform: translateY(-3px);
                background-color: #00b7eb;
              }

              .footer-link {
                transition: all 0.3s ease;
              }

              .footer-link:hover {
                color: #00b7eb !important;
                transform: translateX(5px);
              }

              .icon-box {
                width: 20px;
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              .color-title {
                color: #00b7eb;
              }

              @media (max-width: 768px) {
                .footer-gradient {
                  padding: 3rem 0 !important;
                }

                .color-title {
                  font-size: 1.1rem;
                }

                .footer-link {
                  font-size: 0.9rem;
                }
              }

              @media (max-width: 576px) {
                .footer-gradient {
                  padding: 2rem 0 !important;
                }

                .footer-logo {
                  max-width: 120px !important;
                }

                .social-icon {
                  width: 32px;
                  font-size: 0.9rem;
                }
              }
            `}</style>

            <link
              rel="stylesheet"
              href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
            />
          </footer>
        </div>
      </div>
    </>
  );
};

export default Footer;
